// extracted by mini-css-extract-plugin
export default {"layout":"PlantBackground_layout__ocDh9","noBackground":"PlantBackground_noBackground__ZWcP2","logo":"PlantBackground_logo__Bed1n","pageContent":"PlantBackground_pageContent__6T9kH"};